import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import IconWithText from '../IconWithText';
import { buildContacts } from '../../utils/common';
import { TP, CONTACT_TYPES } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    fontWeight: 'bold',
    marginTop: 4,
  },
});

const ContactLinks = ({ contacts, className, hideInfo, isProfileContact }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  const contactsInfo = buildContacts(contacts);

  const showBoxoffice = contacts?.filter(c => c.contact_category === CONTACT_TYPES.BOX_OFFICE).length > 0;
  const showGeneral = contacts?.filter(c => c.contact_category !== CONTACT_TYPES.BOX_OFFICE).length > 0;

  return (
    <>
      {contacts.length > 0 && (
        <div className={cx(classes.root, className)}>
          {showGeneral && (
            <>
              {Object.values(contactsInfo).map((item, index) => {
                const contact = item.filter(c => c.contact_category !== CONTACT_TYPES.BOX_OFFICE);
                return (
                  contact.length > 0 && (
                    <IconWithText
                      items={contact}
                      key={`icon-${index}`}
                      hideInfo={hideInfo}
                      isProfileContact={isProfileContact}
                    />
                  )
                );
              })}
            </>
          )}
          {showBoxoffice && (
            <>
              <p className={classes.heading}> {t(`${TP}.BOX_OFFICE`)}</p>
              {Object.values(contactsInfo).map((item, index) => {
                const contact = item.filter(c => c.contact_category === CONTACT_TYPES.BOX_OFFICE);
                return (
                  contact.length > 0 && (
                    <IconWithText
                      items={contact}
                      key={`icon-${index}`}
                      hideInfo={hideInfo}
                      isProfileContact={isProfileContact}
                    />
                  )
                );
              })}
            </>
          )}
        </div>
      )}
    </>
  );
};

ContactLinks.propTypes = {
  contacts: PropTypes.array,
  className: PropTypes.string,
  hideInfo: PropTypes.bool,
  isProfileContact: PropTypes.bool,
};

export default ContactLinks;
